import { sendTransaction } from '@biggby-coffee/percomatic-typescript/dist/src/api';
import { makeApiCallHook } from '../../utils/makeApiCallHook';

/*
	THE ONLY THING THAT SHOULD BE ADDED TO THIS FILE ARE ADDITIONAL API CALL
	WRAPPER HOOKS WHEN NEW API METHODS ARE ADDED TO PERCOMATIC
	DO NOT ADD HOOKS WITH AN ACTUAL IMPLEMENTATION TO THIS FILE
*/

export const useSendTransaction = makeApiCallHook(
	'sendTransaction',
	sendTransaction
);
